/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlatformApiResultOfAppDto } from '../../models/platform-api-result-of-app-dto';
import { PlatformCreateApp } from '../../models/platform-create-app';

export interface PostApps$Params {
      body: PlatformCreateApp
}

export function postApps(http: HttpClient, rootUrl: string, params: PostApps$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfAppDto>> {
  const rb = new RequestBuilder(rootUrl, postApps.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlatformApiResultOfAppDto>;
    })
  );
}

postApps.PATH = '/api/apps';
